import { useQuery } from "@tanstack/react-query";
import GlobalAppAPI from "../../api/GlobalAppAPI";
import { useAtomValue } from "jotai";
import { queriesEnabledAtom } from "../../../atoms/GlobalAtoms";

import { ExtendedGlobalApp } from "../../../components/GrowthCloudStore/Cards/AppCard";

// Fetches a global app by ID.
export default function useGlobalApp(
  globalAppID: string | undefined | null,
  disabled = false
) {
  const queriesEnabled = useAtomValue(queriesEnabledAtom);

  const globalApp = useQuery({
    queryKey: ["globalApp", globalAppID],
    queryFn: () =>
      GlobalAppAPI.getGlobalAppByID(globalAppID as string).then(
        (data) => data?.data?.data?.globalApp
      ),
    enabled: !!globalAppID && queriesEnabled && !disabled,
  });

  return {
    globalApp: globalApp.data as ExtendedGlobalApp,
    loadingApp: globalApp.isLoading,
  };
}
